module.exports = __webpack_public_path__ + "img/arrow.00f44318.svg";